module.exports = __webpack_public_path__ + "img/pztype-3.6c294fed.png";